import { FC, useCallback } from 'react';
import { PolicyInsights } from '../../../../containers';
import { useInsights } from '../../api';

const Insights: FC = () => {
    const { data: insights = [], isLoading, isError, refetch: refetchInsights } = useInsights();

    const handleInsightsUpdate = useCallback(() => {
        refetchInsights();
    }, [refetchInsights]);

    return (
        <PolicyInsights
            insights={insights}
            onInsightsUpdate={handleInsightsUpdate}
            showLoading={isLoading}
            showError={isError}
        />
    );
};

export default Insights;
